import PropTypes from 'prop-types';
import { TEXT_BASE_CLASS } from '../Text/Text.constants';

function Textarea({
  placeholder,
  value,
  name,
  isFocus,
  onChange,
  onFocus,
  onBlur,
  required,
  tabIndex,
}) {
  return (
    <div
      className={`aaco-input floating-label aaco-text-area ${
        isFocus ? 'aaco-input--is-focus' : ''
      } ${isFocus || value ? 'aaco-input--is-floating' : ''}`}
    >
      <div
        className={`h-full ${TEXT_BASE_CLASS['body']} normal-case text-black peer grow-wrap w-full`}
        data-replicated-value={value}
      >
        <textarea
          placeholder=" "
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          required={required}
          rows={1}
          tabIndex={tabIndex}
          className="outline-none bg-transparent dd-kr:text-white dd-en:text-white"
          id={name}
          value={value}
        />
      </div>
      <label htmlFor={name} className="peer-placeholder-shown:translate-y-0">
        {placeholder}
      </label>
    </div>
  );
}

Textarea.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  isFocus: PropTypes.bool,
  required: PropTypes.bool,
  tabIndex: PropTypes.number,
};

Textarea.defaultProps = {
  placeholder: '',
  name: '',
  isFocus: false,
  required: false,
};

export default Textarea;
